import { render } from "./ExamDetail.vue?vue&type=template&id=2e1e348f"
import script from "./ExamDetail.vue?vue&type=script&lang=ts"
export * from "./ExamDetail.vue?vue&type=script&lang=ts"

import "./ExamDetail.vue?vue&type=style&index=0&id=2e1e348f&lang=css"
script.render = render

export default script